import loadable from '@loadable/component';

const Component = loadable(() => import('./Jobs'));

export default Component;
